import contract from "./contractData.json";

export type CommandPhase =
  "main" | "entry" | "item" | "player" | "npc" | "monster" | "misc";

const wildcardToRegExp = (pattern: string) => {
  const parts = pattern.split(".");
  return new RegExp(
    `^${parts.map((part, index) => (part === "*" ? (index === parts.length - 1 ? ".+" : "[^.\\[\\]]+") : part.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))).join("\\.")}$`,
  );
};
const writable = contract.writablePaths.map((entry) => ({
  ...entry,
  matcher: wildcardToRegExp(entry.pattern),
}));
const forbidden = contract.forbiddenPaths.map(wildcardToRegExp);

export interface PathDecision {
  allowed: boolean;
  reason: string;
  owner?: string;
}

export function decideStatePath(
  path: string,
  phase: CommandPhase,
): PathDecision {
  const normalized = path
    .trim()
    .replace(/\[(?:"|')?([^\]"']+)(?:"|')?\]/g, ".$1")
    .replace(/^archive\./, "");
  if (forbidden.some((matcher) => matcher.test(normalized)))
    return {
      allowed: false,
      reason: `代码派生或结算字段禁止 LLM 写入：${normalized}`,
    };
  const matched = writable.find((entry) => entry.matcher.test(normalized));
  if (!matched)
    return { allowed: false, reason: `路径不在 MH 状态契约中：${normalized}` };
  if (!(matched.phases as string[]).includes(phase))
    return {
      allowed: false,
      reason: `${phase} 阶段无权写入 ${normalized}`,
      owner: matched.owner,
    };
  return { allowed: true, reason: "allowed", owner: matched.owner };
}
